import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { Icon } from 'components/Icons'
import styles from './BottomNav.module.scss'

/**
 * Нижняя навигационная панель для мобильных устройств.
 * Появляется только на узких экранах (max-width: 768px).
 *
 * Использование:
 *   <BottomNav items={[
 *     { key: 'home', icon: 'home', label: 'Главная', path: '/home' },
 *     { key: 'schedule', icon: 'schedule', label: 'Расписание', path: '/schedule' },
 *     { key: 'journal', icon: 'journal', label: 'Журнал', path: '/journal' },
 *     { key: 'chat', icon: 'message', label: 'Чат', path: '/chats' },
 *     { key: 'profile', icon: 'user', label: 'Профиль', path: '/personalcard' },
 *   ]} />
 */
const BottomNav = ({ items = [], hidden = false }) => {
  const { t } = useTranslation('common')
  const navigate = useNavigate()
  const location = useLocation()

  const isActive = (path) => location.pathname === path || location.pathname.startsWith(path + '/')

  return (
    <nav
      className={`${styles.bottomNav} ${hidden ? styles.hidden : ''}`}
      aria-label={t('auto.unvui_bottomnav.aria', 'Нижняя навигация')}
      aria-hidden={hidden || undefined}>
      {items.map((it) => (
        <button
          key={it.key}
          type="button"
          className={`${styles.item} ${isActive(it.path) ? styles.active : ''}`}
          onClick={() => navigate(it.path)}
          aria-label={it.label}
          aria-current={isActive(it.path) ? 'page' : undefined}
        >
          <Icon
            name={it.icon}
            size={22}
            color={isActive(it.path) ? 'var(--color-accent)' : 'var(--color-text-muted)'}
          />
          <span className={styles.label}>{it.label}</span>
        </button>
      ))}
    </nav>
  )
}

export default BottomNav
